// extracted by mini-css-extract-plugin
module.exports = {"add":"OrgSettings_add__35Rzk","remove":"OrgSettings_remove__3eOP0"};